var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [
        _vm._v("Distribution Domain")
      ]),
      _c("div", { staticClass: "md-subheading domain-hint" }, [
        _vm._v("Enter the domain where this distribution is served")
      ]),
      _c(
        "md-input-container",
        {
          staticClass: "domain-input",
          class: { "md-input-invalid": _vm.showDomainError }
        },
        [
          _vm.showDomainError
            ? _c("span", { staticClass: "md-error" }, [
                _vm._v("Enter a valid domain (e.g. example.com)")
              ])
            : _vm._e(),
          _c("label", [_vm._v("Domain")]),
          _c("md-input", {
            attrs: { type: "text", placeholder: "example.com" },
            model: {
              value: _vm.playerSettings.domain,
              callback: function($$v) {
                _vm.$set(_vm.playerSettings, "domain", $$v)
              },
              expression: "playerSettings.domain"
            }
          })
        ],
        1
      ),
      _vm.playerSettings.domain
        ? _c("div", { staticClass: "domain-preview" }, [
            _c("span", { staticClass: "domain-label" }, [
              _vm._v("Preview URL structure: ")
            ]),
            _c("code", { staticClass: "domain-example" }, [
              _vm._v(
                _vm._s(_vm.normalizedDomain) + "?videoSlug=video-slug-123456"
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3de2e6e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3de2e6e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/distribution/form-components/PlayerSettingsForm.vue
// module id = 770
// module chunks = 0